"use strict";
import Swiper from 'swiper';
import { Scrollbar } from 'swiper/modules';

document.addEventListener("DOMContentLoaded", () => {
    opinionsSlider();
});

const opinionsSlider = () => {
    document.querySelectorAll(".opinions").forEach((slider) => {
        const scrollbarEl = slider.querySelector(".swiper-scrollbar");
        const sliderEl = slider.querySelector(".slider-opinions-slider");
        const slidesCount = 3;

        const opinionsSliderSlider = new Swiper(sliderEl, {
            modules: [Scrollbar],
            slidesPerView: 1,
            speed: 1000,
            scrollbar: {
                el: scrollbarEl,
                draggable: true,
            },
            breakpoints: {
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 2 },
                1300: { slidesPerView: slidesCount }
            }
        });
    });
};

